import { getEmployees } from '@/modules/employees/services/EmployeeService'
import GetEmployessInputDto from '@/modules/employees/services/interfaces/GetEmployeeInputDto'
import { EmployeeDetail } from '@/modules/employees/models/EmployeeDetail'

export default async function useEmployees(
  dto: GetEmployessInputDto
): Promise<EmployeeDetail[]> {
  const response = await getEmployees(dto)
  return response.data
}
